export default "__VITE_ASSET__WrIbxXD8__"